import { Tooltip, TooltipProps } from "@mui/material";
import { withDisplayName } from "../../utils/displayName";

withDisplayName(Tooltip, "Tooltip");
export type { TooltipProps };
export default Tooltip;

export const TooltipPlacementOptions = [
  "bottom-end",
  "bottom-start",
  "bottom",
  "left-end",
  "left-start",
  "left",
  "right-end",
  "right-start",
  "right",
  "top-end",
  "top-start",
  "top",
];
export type TooltipPlacement = (typeof TooltipPlacementOptions)[number];
